import {
  CLEAR_VALIDATION,
  ADD_VALIDATION_CHECK_START,
  ADD_VALIDATION_CHECK_SUCCESS,
  ADD_VALIDATION_CHECK,
  DISPATCH_ADD_VALIDATION_CHECK,
  REMOVE_VALIDATION_CHECK_START,
  REMOVE_VALIDATION_CHECK_SUCCESS,
  REMOVE_VALIDATION_CHECK,
  DISPATCH_REMOVE_VALIDATION_CHECK,
  DISPATCH_VALIDATE_FORM,
  DISPATCH_VALIDATE_FORM_START,
  DISPATCH_VALIDATE_FORM_SUCCESS,
  REGISTER_ELEMENT,
  UPDATE_VALIDATION_VALUE,
} from './constants'

const addValidationCheckStart = () => ({ type: ADD_VALIDATION_CHECK_START })
const addValidationCheckSuccess = () => ({ type: ADD_VALIDATION_CHECK_SUCCESS })
const addValidationCheck = (id) => ({ type: ADD_VALIDATION_CHECK, id })
const dispatchAddValidationCheck = (id) => ({ type: DISPATCH_ADD_VALIDATION_CHECK, id })
const removeValidationCheckStart = () => ({ type: REMOVE_VALIDATION_CHECK_START })
const removeValidationCheckSuccess = () => ({ type: REMOVE_VALIDATION_CHECK_SUCCESS })
const removeValidationCheck = (id) => ({ type: REMOVE_VALIDATION_CHECK, id })
const dispatchRemoveValidationCheck = (id) => ({ type: DISPATCH_REMOVE_VALIDATION_CHECK, id })
const clearValidation = () => ({ type: CLEAR_VALIDATION })
// will global dispatch validate form
const dispatchValidateForm = () => ({ type: DISPATCH_VALIDATE_FORM })
const dispatchValidateFormStart = () => ({ type: DISPATCH_VALIDATE_FORM_START })
const dispatchValidateFormSuccess = () => ({ type: DISPATCH_VALIDATE_FORM_SUCCESS })
// elements must be initially registered or it won't me updated
const registerElement = (id) => ({ type: REGISTER_ELEMENT, id })
const updateValidationValue = () => ({ type: UPDATE_VALIDATION_VALUE })

export {
  clearValidation,
  addValidationCheckStart,
  addValidationCheckSuccess,
  addValidationCheck,
  dispatchAddValidationCheck,
  removeValidationCheckStart,
  removeValidationCheckSuccess,
  removeValidationCheck,
  dispatchRemoveValidationCheck,
  dispatchValidateForm,
  dispatchValidateFormStart,
  dispatchValidateFormSuccess,
  registerElement,
  updateValidationValue,
}
